import {
  setPortalData,
  setPortalProcessing,
  setPortalError,
  GET_PORTAL_DATA,
  GET_PORTALS_DATA,
  CREATE_PORTAL_DATA,
  UPDATE_PORTAL_DATA,
} from './actions'
import {
  getUserPortal,
  getUserPortals,
  postUserPortal,
  putUserPortal,
} from '..'

const log = console

async function getPortalDataHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action
  try {
    store.dispatch(setPortalProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      uid: payload,
    }

    const data = await getUserPortal(options)

    store.dispatch(setPortalData({
      data,
    }))
  } catch (error) {
    log.error(error, 'Error getting user portal.')
    store.dispatch(setPortalError({
      error,
    }))
  }
}

async function getPortalsDataHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action
  try {
    store.dispatch(setPortalProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      query: payload,
    }

    const data = await getUserPortals(options)

    store.dispatch(setPortalData({
      data,
    }))
  } catch (error) {
    log.error(error, 'Error getting user portals.')
    store.dispatch(setPortalError({
      error,
    }))
  }
}

async function createPortalDataHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action
  try {
    store.dispatch(setPortalProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      body: payload,
    }
    const data = await postUserPortal(options)
    store.dispatch(setPortalData({
      data,
    }))
  } catch (error) {
    log.error(error, 'Error getting user portal.')
    store.dispatch(setPortalError({
      error,
    }))
  }
}

async function updatePortalDataHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { payload } = action
  const {
    url, username, uid, uuid, verifiedAuthentic, privacySetting, id, locked, tier,
  } = payload
  try {
    store.dispatch(setPortalProcessing({}))
    const options = {
      server: config.getIn(['data', 'servers', 'brooklyn']),
      verifiedAuthentic,
      privacySetting,
      username,
      locked,
      tier,
      auth,
      url,
      uuid,
      uid,
      id,
    }

    await putUserPortal(options)
  } catch (error) {
    log.error(error, 'Error updating user portal.')
    store.dispatch(setPortalError({
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_PORTAL_DATA:
      getPortalDataHandler({ store, action })
      break
    case GET_PORTALS_DATA:
      getPortalsDataHandler({ store, action })
      break
    case CREATE_PORTAL_DATA:
      createPortalDataHandler({ store, action })
      break
    case UPDATE_PORTAL_DATA:
      updatePortalDataHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
